import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '../backend';
import { projectsBackend } from './projects.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { projectsReducer } from './projects.reducer';

// FIXME: remove that
backend.projects = projectsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('projects', projectsReducer),
    /* DatastoreBackendModule.forFeature(
      'projects',
      projectsBackend,
    ),*/
  ],
})
export class DatastoreProjectsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/projects/projects.module.ts